import { has } from "../../../../../utils/menu-context";
export const createConditionAction = () => {
    return {
        canEdit: ({ props }) => {
            let result = false
            const { menuContext } = props
            if (!has({ menuContext, key: 'canEdit' })) return false
            if (has({ menuContext, key: 'forCompany' })) {
                result = true || result
            }
            return result
        },
    }
    }


export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ['idCard', 'username'].includes(field?.key)
            },
            inputPropField: ({ props, modelRef }) => ({ disabled: modelRef.id || props.viewOnly })
        },
        {
            check: ({ field }) => ['password', 'confirmPassword'].includes(field?.key),
            visibleField: ({ modelRef }) => !modelRef.id,
        },
        // {
        //     check: ({ sectionKey }) => {
        //         return ['UserCompanyChildren'].includes(sectionKey)
        //     },
        //     visibleSection: ({ modelRef }) => {
        //         return modelRef
        //     },
        //     enable: ({ props }) => {
        //         const { menuContext, viewOnly } = props
        //         let enabled = false
        //         if (has({ menuContext, key: 'forCompany' })) {
        //             enabled = !viewOnly || enabled
        //         }
        //         return enabled
        //     }
        // },
    ]
}